/** @format */
import { css } from 'styled-components';

import { generateGridTemplateColumns } from '@toucan/helpers/styles';

import { StyledGridRepeaterProps } from './index';
import { generateGridTemplateAreas } from './style-helpers';

const baseStyles = ({
    gridColumns = 4,
    gridGap = 'var(--layout-spacing-48)',
}: StyledGridRepeaterProps) => {
    return css`
        ${generateGridTemplateAreas(gridColumns)}
        ${generateGridTemplateColumns(gridColumns)}

        display: -ms-grid;
        display: grid;
        grid-gap: ${gridGap};

        .grid-item-container > * {
            height: 100%;
        }
    `;
};

/**
 * The grid repeater component styles
 *
 * @param {StyledGridRepeaterProps} props The grid repeater properties object
 * */
export const styles = (props: StyledGridRepeaterProps) => css`
    ${baseStyles(props)}
`;
